<template>
  <section class="search-result-container">
    <header class="header">
      <template v-if="!hideMenu">
        <select-box
          v-if="fileCount > 0"
          @action="selectAll"
          :selected="fileCount === selectedFileIds.length"
        ></select-box>
        Naam
      </template>
    </header>
    <main class="search-result-main">
      <div class="not-found" v-if="searchInProgress">
        <bouncing-spinner></bouncing-spinner>
      </div>
      <div class="not-found" v-else-if="searchResultCount === 0">
        Niets gevonden
      </div>
      <ul class="list" v-else>
        <li
          tag="li"
          v-for="(result, index) in searchResults"
          :key="index"
          class="fs-search-result pointer"
          :transfer-data="result"
          :image-x-offset="60"
          :image-y-offset="60"
        >
          <div slot="image">
            <div
              v-if="result.type === 'FILE'"
              class="file-drag-image-container"
            >
              <div class="file-drag-image">{{ selectedFileIds.length }}</div>
            </div>
          </div>
          <div v-if="!hideMenu">
            <select-box
              v-if="result.type === 'FILE'"
              @action="toggleSelectedFile(result.fileId)"
              :selected="selectedFileIds.includes(result.fileId)"
            ></select-box>

            <div class="select-box-ph" v-if="result.type !== 'FILE'"></div>
          </div>

          <div class="name-path" @click="selectFile(result)">
            <span class="name">
              <span :class="{ folder: result.type === 'FOLDER' }">
                <span
                  v-if="result.snippets.name"
                  v-html="result.snippets.name"
                ></span>
                <span v-else>{{ result.name }}</span>
              </span>

              <div
                class="select-badge sub-color-background"
                v-if="result.type === 'FILE'"
              ></div>
            </span>
            <div v-if="result.deleted" class="split-path">
              <span>Prullenmand</span>
            </div>

            <div class="split-path" v-if="!result.deleted">
              <span v-for="(path, index) in result.splitPath" :key="index"
                >{{ path }}<i class="chevron right"></i
              ></span>
            </div>
            <div
              v-if="result.snippets.contents"
              class="snippet"
              v-html="result.snippets.contents"
            ></div>
          </div>
          <div class="folder-ph">
            <span v-show="result.type === 'FOLDER'" class="folder">Map</span>
          </div>
          <span class="" v-show="result.type === 'ARCHIVE'">Archief</span>

          <popup-menu anchor-position="right" v-if="!hideMenu">
            <button class="kebab-btn" slot="trigger"><span></span></button>
            <template v-if="result.type === 'FILE'">
              <menu-item @click="navigateToTargetFolder(result.folderId)"
                >Ga naar map</menu-item
              >
              <menu-item @click="viewFile(result)">Bekijken</menu-item>
              <menu-item @click="download(result)">Downloaden</menu-item>
              <menu-item @click="getFileInfo(result)">Info</menu-item>
            </template>

            <template v-if="result.type === 'FOLDER'">
              <menu-item @click="getFileInfo(result)">Info</menu-item>
              <menu-item @click="navigateToTargetFolder(result.folderId)"
                >Ga naar map</menu-item
              >

              <template
                v-if="
                  result.permissions === 'write' ||
                  result.permissions === 'admin'
                "
              >
                <menu-item @click="trashFolder(result)"
                  >Naar prullenmand</menu-item
                >
              </template>
            </template>

            <template v-if="result.type === 'ARCHIVE'">
              <menu-item @click="getFileInfo(result)">Info</menu-item>
              <menu-item @click="navigateToTargetFolder(result.folderId)"
                >Ga naar archief</menu-item
              >
            </template>
          </popup-menu>
        </li>
      </ul>
    </main>
  </section>
</template>
<script>
import FileNavigationMixin from '@/features/filestore/FileNavigationMixin.js'
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'

export default {
  props: {
    hideMenu: {
      type: Boolean,
      default: false
    }
  },
  mixins: [FileNavigationMixin],
  data() {
    return {
      hoverIndex: undefined,
      selectedFiles: []
    }
  },
  computed: {
    ...mapStores(useFileStoreStore),
    searchResults() {
      return this.fileStoreStore.searchResults
    },
    searchResultCount() {
      return this.fileStoreStore.searchResultCount
    },
    selectedFileIds() {
      return this.fileStoreStore.browserSelectedFileIds
    },
    fileCount() {
      return this.fileStoreStore.searchResults.filter(
        (item) => item.type === 'file'
      ).length
    },
    searchInProgress() {
      return this.fileStoreStore.searchInProgress
    }
  },
  methods: {
    download(file) {
      let toDownload = []
      if (this.selectedFileIds.length < 2) {
        toDownload[0] = file.fileId
      } else {
        toDownload = this.selectedFileIds
      }
      this.downloadFile(toDownload)
    },
    selectFile(file) {
      if (file.type === 'file') {
        this.toggleSelectedFile(file.fileId)
      } else {
        this.navigateToTargetFolder(file.folderId)
      }
    },
    selectAll() {
      if (this.fileCount === this.selectedFileIds.length) {
        this.files
          .filter((file) => file.type === 'file')
          .forEach((file) =>
            this.fileStoreStore.browserDeSelectFileId(file.fileId)
          )
      } else {
        this.files
          .filter((file) => file.type === 'file')
          .forEach((file) =>
            this.fileStoreStore.browserSelectedFileId(file.fileId)
          )
      }
    }
  },
  unmounted() {
    this.fileStoreStore.setSearchResults([])
    this.fileStoreStore.clearBrowserSelectedFileIds()
  }
}
</script>
<style scoped lang="scss">
.search-result-container {
  height: 100%;
}

.split-path {
  padding-top: 3px;
  span {
    font-size: 11px;
    color: #9e9e9e;
    font-weight: 500;
  }

  i {
    display: inline-block;
    transform: scale(0.7);
    margin: 0 4px;
  }
}

.select-box-ph {
  min-width: 22px;
  max-width: 22px;
}

.folder {
  font-weight: 600;
}

.folder-ph {
  min-width: 35px;
  line-height: 19px;
}

.name {
  line-height: 19px;
}

.fs-search-result {
  display: flex;
  align-items: flex-start;
  height: auto;
  min-height: 64px;
  padding: 15px 10px;

  > span {
    margin-bottom: 15px;
  }

  /*   span.btn {
    margin-bottom: 3px;
  } */

  select-box {
    margin-top: 3px;
  }

  .snippet {
    margin-top: 2px;
    line-height: 24px;
  }

  .select-box {
    margin-top: 4px;
    min-width: 18px;
  }
}

.header {
  border-bottom: 1px solid #e6e6e6;
  height: 38px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;

  .select-box {
    margin-right: 14px;
  }
}

.search-result-main {
  overflow: auto;
  height: calc(100% - 38px);
}

.not-found {
  padding: 16px 36px;
  //font-size: 12px;
  font-style: italic;
  color: #a9a9a9;
}

.file-drag-image-container {
  position: relative;
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-drag-image {
  color: var(--sub-color);
  font-size: 53px;
  font-weight: 500;
  display: flex;
  background-color: rgba(255, 255, 255, 0.75);
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  box-shadow: rgba(0, 0, 0, 0.5) 0 0 6px;
}
</style>
